import { ICareMap } from '../caremap/ICareMap';
import { InnerhivePage } from '../InnerhivePage';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { CareMapState } from '../caremap/CareMapState';
import { ActiveCareMapProviderV2 } from '../ActiveCareMapProvider';
import { Route } from 'react-router';
import { AppointmentsList } from './AppointmentsList';
import { AppointmentEditorDrawer } from './AppointmentEditorDrawer';
import { IonButtons, IonToolbar } from '@ionic/react';
import { Text } from '../components/Text';
import { AddAppointmentButton } from './AddAppointmentButton';
import { AppointmentsState, NEW_APPOINTMENT_ID } from './AppointmentsState';
import { useEffect } from 'react';
import { MixPanelEventEmitter } from '../metrics/MixPanelEventEmitter';

export const AppointmentsPageRouteHandler: React.FC = () => (
    <Route path="/appointments/:caremapId" render={routeParams => (
        <ActiveCareMapProviderV2 careMapId={routeParams.match.params.caremapId}>
            <ActiveCaremapAppointmentsPage />
        </ActiveCareMapProviderV2>
    )} />
);

export const ActiveCaremapAppointmentsPage: React.FC = () => {
    const caremapState = useInstance(CareMapState);
    const caremap = caremapState.getActiveCaremap() as ICareMap;
    const drawer = useInstance(AppointmentEditorDrawer);
    const appointmentsState = useInstance(AppointmentsState);
    const mixpanel = useInstance(MixPanelEventEmitter);

    const patientFirstName = caremapState.getPatientFirstName(caremap);

    const title = `${patientFirstName}'s Appointments`;

    useEffect(() => {
        mixpanel.trackWithDebounce({ event: 'Appointments Page Opened' });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const editAppointment = (appointmentId: string) => {
        if (appointmentId === NEW_APPOINTMENT_ID) {
            appointmentsState.trackNewAppointmentOpened({from: 'Appointments Page'});
        }

        drawer.open({ appointmentId });
    };

    return (
        <InnerhivePage title={title}>
            <IonToolbar>
                <Text type="title">Appointments</Text>
                <IonButtons slot="end">
                    <AddAppointmentButton
                        onClick={editAppointment}
                        canAdd={appointmentsState.canAdd()}
                    />
                </IonButtons>
            </IonToolbar>
            <AppointmentsList
                showHeading={false}
                data-type="more-appointments-list"
                editAppointment={editAppointment}
            />
        </InnerhivePage>
    );
};
